var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStretchTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 6H11.5C8.467 6 6 8.468 6 11.5V36.5C6 39.532 8.467 42 11.5 42H36.5C39.533 42 42 39.532 42 36.5V11.5C42 8.468 39.533 6 36.5 6ZM37 19.5C37 20.328 36.329 21 35.5 21C34.671 21 34 20.328 34 19.5V16.121L16.121 34H19.5C20.329 34 21 34.672 21 35.5C21 36.328 20.329 37 19.5 37H12.5C12.306 37 12.123 36.96 11.953 36.893C11.945 36.89 11.938 36.889 11.93 36.886C11.56 36.734 11.266 36.439 11.113 36.069C11.11 36.062 11.109 36.054 11.106 36.046C11.04 35.877 11 35.694 11 35.5V28.5C11 27.672 11.671 27 12.5 27C13.329 27 14 27.672 14 28.5V31.879L31.879 14H28.5C27.671 14 27 13.328 27 12.5C27 11.672 27.671 11 28.5 11H35.5C35.694 11 35.877 11.04 36.047 11.107C36.054 11.11 36.062 11.111 36.07 11.114C36.44 11.266 36.734 11.561 36.887 11.931C36.89 11.938 36.891 11.946 36.894 11.954C36.96 12.123 37 12.306 37 12.5V19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStretchTool);
export default __webpack_public_path__ + "static/media/stretch-tool.cc24ab9110eb349783e863212e4ff546.svg";
export { ForwardRef as ReactComponent };